export const renderLineNumber = (hasTitle = true, width = 80) => {
	return hasTitle
		? {
				title: '',
				width,

				children: [
					{
						title: '№',
						dataIndex: 'No',
						key: 'No',
						align: 'center',

						render: (_, record, index) => {
							const skip = (record.skip || 0) + index + 1
							return skip
						},
					},
				],
			}
		: {
				title: '№',
				dataIndex: 'No',
				key: 'No',
				align: 'center',
				width,
				render: (_, record, index) => {
					const skip = (record.skip || 0) + index + 1
					return skip
				},
			}
}

export const changePagination = ({
	page,
	pageSize,
	setCurrentPage,
	setPageSize,
}) => {
	setCurrentPage(page - 1)
	setPageSize(pageSize)
}

export const changePageSize = ({
	current,
	pageSize,
	setCurrentPage,
	setPageSize,
}) => {
	setCurrentPage(0)
	setPageSize(pageSize)
}
